import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-survery',
  templateUrl: './survery.component.html',
  styleUrls: ['./survery.component.scss']
})
export class SurveryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
